<!--
 * @Description: 素材库文件管理
 * @Author: hasayake
 * @Date: 2020-05-07 14:05:20
 * @LastEditTime: 2020-07-06 16:08:14
 * @LastEditors: Please set LastEditors
-->

<template>
  <div class="files-manage">
    <section class="files-path">
      <span
        class="files-path-item"
        v-for="(item, idx) in filePaths"
        :key="item.id"
      >
        <span @click="pathChangeHandler({ idx, id: item.id })">{{
          item.name
        }}</span>
        <i class="el-icon-arrow-right" />
      </span>
    </section>

    <section class="check-handler__show">
      <el-checkbox v-show="checkboxs.nums" v-model="checkboxs.val">{{
        checkStatus
      }}</el-checkbox>
      <div class="handlers">
        <!-- <el-button
          type="primary"
          size="small"
          icon="el-icon-upload"
          class="input-upload"
        >
          上传文件
          <input type="file" multiple @change="fileChangeHandler" />
        </el-button> -->
        <el-select
          size="small"
          v-model="selectVal"
          clearable
          @change="selectChangHandler"
          class="search-select"
        >
          <el-option
            v-for="item in selectList"
            :key="item.number"
            :label="item.projectName"
            :value="item.number"
          >
          </el-option>
        </el-select>
        <el-button
          size="small"
          type="primary"
          :disabled="channelBtnDisabled"
          @click="openDialog('syncMaterials')"
          >同步至渠道素材</el-button
        >
        <!-- <el-button
          type="primary" size="small"
          @click="uploadMaterialHandler">
          上传素材
        </el-button> -->

        <el-button
          type="primary"
          size="small"
          class="input-upload"
          @click="openDialog('uploadMaterials')"
        >
          上传素材
        </el-button>

        <!-- <el-button
          type="primary"
          plain
          size="small"
          class="input-upload upload-url-btn"
          @click="openDialog('uploadUrl')"
        >
          上传URL
        </el-button> -->
        <el-button size="small" icon="el-icon-plus" @click="addNew"
          >新建</el-button
        >
        <!-- <el-button type="primary" size="small" icon="el-icon-download" :disabled="!checkboxs.nums">下载</el-button> -->
        <el-button
          type="danger"
          size="small"
          icon="el-icon-delete"
          :disabled="!checkboxs.nums"
          @click="deleteHandler"
          >删除</el-button
        >
      </div>
    </section>
    <section class="mode-show">
      <el-button
        :class="{ cur: mode === 'table' }"
        icon="el-icon-s-fold"
        type="text"
        @click="modeChange('table')"
      />
      <el-button
        :class="{ cur: mode === 'grid' }"
        icon="el-icon-menu"
        type="text"
        @click="modeChange('grid')"
      />
    </section>

    <!-- 文件列表管理--主要 -->
    <file-list-manage
      v-if="mode === 'grid'"
      v-loading="loading"
      :fileList="fileList"
      @itemDbClick="itemDbClick"
      @checkChange="checkChange"
      @playVideo="playVideoHandler"
    />

    <!-- 文件列表管理--表格形式展示 -->
    <table-list-manage
      v-else
      :fileList="fileList"
      v-loading="loading"
      @itemDbClick="itemDbClick"
      @checkChange="checkChange"
      @playVideo="playVideoHandler"
    />

    <drawer-add-edit @save="addSaveHandler" v-model="drawers.show" />

    <upload-materials
      v-model="uploadMaterials.show"
      :filePaths="filePaths"
      :curDirId="curDirId"
      :projectId="selectVal"
      @refresh="getDirHandler(curDirId)"
    />

    <upload-url
      v-model="uploadUrl.show"
      :curDirId="curDirId"
      @refresh="getDirHandler(curDirId)"
    />

    <sync-to-channel-material
      v-model="syncMaterials.show"
      :projectId="selectVal"
      :platform="currentPlatform"
      :checkedList="checkboxs.list"
      @refresh="selectChangHandler(selectVal)"
    />

    <review-material
      v-show="reviews.show"
      :materialItem="reviews.item"
      @close="closeReviewHandler"
    />
  </div>
</template>

<script>
import { uploadFileToOSS, materialLibrarysHandler } from "@/assets/js/api";
import { UPLOAD_ALLOW_SUFFIX_LIST } from "@/assets/js/config";

import drawerAddEdit from "./drawerAddEdit";
import fileListManage from "./fileListManage";
import tableListManage from "./tableList";
import uploadMaterials from "./uploadMaterials";
import syncToChannelMaterial from "./syncToChannelMaterial";
import uploadUrl from "./uploadUrl";
import reviewMaterial from "@/components/LibraryReview.vue";

export default {
  name: "fileManage",

  components: {
    drawerAddEdit,
    fileListManage,
    tableListManage,
    uploadMaterials,
    syncToChannelMaterial,
    uploadUrl,
    reviewMaterial
  },

  data() {
    return {
      reviews: {
        show: false
      },
      selectVal: "",
      uploadMaterials: {
        show: false
      },
      syncMaterials: {
        show: false
      },
      uploadUrl: {
        show: false
      },
      mode: "table",
      filePaths: [],
      checkboxs: {
        val: false,
        list: [],
        nums: 0
      },
      fileList: [],
      drawers: {
        show: false
      },
      ossConfigs: {},
      curDirId: null,
      loading: false,
      selectList: [],
      currentPlatform: 0,
      uploadMaterialShow: false
    };
  },

  computed: {
    checkStatus() {
      let text = "";
      if (this.checkboxs.nums) {
        this.checkboxs.val = true;
        text = `已选择 ${this.checkboxs.nums} 项 / 共 ${this.fileList.length} 项`;
      } else {
        this.checkboxs.val = false;
        text = `共 ${this.fileList.length} 项`;
      }

      return text;
    },
    channelBtnDisabled() {
      //判断选中的是否全为文件，文件夹不可操作
      const isFile = this.checkboxs.list.every(item => {
        return item.type === 1;
      });
      // 项目 和 选中的文件必须有
      return !(this.selectVal && isFile && this.checkboxs.list.length);
    }
  },

  methods: {
    uploadMaterialHandler() {
      this.uploadMaterialShow = true;
    },
    playVideoHandler(item) {
      this.openDetailBoxHandler(item);
    },

    openDetailBoxHandler(item) {
      this.reviews.show = true;
      this.reviews.item = item;
    },

    closeReviewHandler() {
      this.reviews.show = false;
    },
    selectChangHandler(val) {
      this.filePaths = [];
      this.getRootHandler(val);
      const currentIndex = this.selectList.findIndex(item => {
        return item.number === val;
      });
      if (currentIndex < 0) return;
      this.currentPlatform = this.selectList[currentIndex].platform;
    },

    openDialog(key) {
      this[key].show = true;
    },

    modeChange(mode) {
      this.mode = mode;
    },

    addSaveHandler(dirName) {
      materialLibrarysHandler
        .create({
          dirName,
          parentId: this.curDirId
        })
        .then(res => {
          this.drawers.show = false;
          this.getDirHandler(this.curDirId);
        })
        .catch(err => {
          this.$message.error(err.msg);
        });
    },

    addNew() {
      this.drawers.show = true;
    },

    deleteHandler() {
      gtag("event", "file", {
        event_category: "delete",
        event_label: "delete_file"
      });

      const [docIds, dirIds] = this.checkboxs.list.reduce(
        (total, cur) => {
          if (cur.type === 1) {
            total[0].push(cur.fileId);
          }
          if (cur.type === 2) {
            total[1].push(+cur.fileId);
          }
          return total;
        },
        [[], []]
      );

      materialLibrarysHandler
        .deleteFiles({ dirIds, docIds })
        .then(res => {
          this.$message.success(res.msg);
          this.$bus.$emit("setEmpty");
          this.getDirHandler(this.curDirId);
        })
        .catch(err => {
          this.$message.success(err.msg);
        });
    },

    checkChange(checkList) {
      this.checkboxs.list = checkList;
      this.checkboxs.nums = checkList.length;
      let files = JSON.parse(JSON.stringify(this.fileList));
      files.map(item => {
        item.check = false;
      });
      for (let check of checkList) {
        const index = files.findIndex(file => {
          return file.fileId === check.fileId;
        });
        if (index >= 0) {
          this.fileList[index].check = true;
          files[index].check = true;
        }
      }
      this.fileList = [];
      this.fileList = files;
    },

    // 路径变更
    pathChangeHandler({ idx, id }) {
      // 最后一个为当前路径，需排除
      if (idx !== this.filePaths.length - 1) {
        this.filePaths = this.filePaths.slice(0, idx + 1);
        this.curDirId = id;
        // 重置选中
        this.$bus.$emit("setEmpty");
        this.getDirHandler(id);
      }
    },

    // 获取root目录
    getRootHandler(val) {
      this.loading = true;
      materialLibrarysHandler.getRoot(val ? val : "").then(res => {
        setTimeout(() => {
          this.loading = false;
        }, 300);
        if (res.code !== 200) {
          this.$message.error(res.msg);
          return;
        }
        const { data } = res;
        this.fileList = data.children;
        this.filePaths.push({
          name: data.projectName || "全部",
          id: data.rootDirId
        });
        this.checkChange([]); //重置选中

        this.curDirId = data.rootDirId;
      });
    },

    // 获取 dir 目录
    getDirHandler(val) {
      this.loading = true;
      materialLibrarysHandler
        .getDir(val)
        .then(res => {
          this.fileList = res.data;
          this.checkChange([]); //重置选中

          setTimeout(() => {
            this.loading = false;
          }, 300);
        })
        .catch(err => {
          this.$message.error(err.msg);
        });
    },

    // 文件夹目录双击
    itemDbClick(val) {
      this.filePaths.push(val);
      this.curDirId = val.id;
      // 重置选中
      this.$bus.$emit("setEmpty");
      // todo 调用获取 getDir 接口
      this.getDirHandler(val.id);
    },

    // 文件选择上传
    async fileChangeHandler(e) {
      const ev = e || window.event;
      const file = ev.target.files[0];
      const suffix = file.name
        .split(".")
        .slice(-1)[0]
        .toLowerCase();

      // 判断文件名是否含有敏感字符
      if (/(#|%|\+)+/g.test(file.name)) {
        this.$message.warning("文件名不能含有特殊符号，如 #，%，+ 等。");
        return false;
      }

      if (UPLOAD_ALLOW_SUFFIX_LIST.includes(`.${suffix}`)) {
        let filePaths = this.filePaths.map(item => item.id).join("/") + "/";

        /**
         * 将文件上传到 oss，获取返回的文件在线地址
         * 即使上传成功也没有返回值
         * 使用 await 强制阻塞
         */
        await uploadFileToOSS(
          this.ossConfigs,
          file,
          filePaths,
          file.name.replace(/(_|\/)/g, ""),
          () => {}
        );

        this.ossFilePathToEndHandler({
          name: file.name.replace(/(_|\/)/g, ""),
          path: filePaths
        });
      } else {
        this.$message.error("文件格式不正确");
      }
    },

    // 获取 oss 配置
    getOssConfigs() {
      materialLibrarysHandler
        .getOssConfig()
        .then(res => {
          this.ossConfigs = res.data;
        })
        .catch(err => {
          this.$message.error(err.msg);
        });
    },

    // 将 oss 文件路径发送给后台
    ossFilePathToEndHandler({ name, path }) {
      const filePath = `http://${this.ossConfigs.bucketName +
        "." +
        this.ossConfigs.endpoint}/${path + name}`;

      materialLibrarysHandler
        .upload({
          parentId: +this.curDirId,
          urls: [filePath]
        })
        .then(res => {
          this.$message.success(res.msg);
          this.getDirHandler(this.curDirId);
        })
        .catch(err => {
          this.$message.error(err.msg);
        });
    },

    getProjectList() {
      materialLibrarysHandler.getProject().then(res => {
        this.selectList = res.data;
        // 设置项目ID
        const pid = this.$route.query.projectId;
        this.selectVal = pid || "";
        // 获取 root
        this.getRootHandler(this.selectVal);
      });
    }
  },

  created() {
    // 获取 oss config
    this.getOssConfigs();

    // 获取 root
    // this.getRootHandler();

    // 获取项目信息
    this.getProjectList();
  }
};
</script>

<style lang="scss">
.files-manage {
  padding: 20px 30px;
  text-align: left;
  height: calc(100vh - 120px);
  min-height: 600px;
  background-color: #fff;
  button {
    height: auto;
  }

  .files-path {
    margin-bottom: 10px;
  }

  .mode-show {
    text-align: right;

    .el-button {
      font-size: 20px;
      color: #999;
    }

    .cur {
      color: #1983f9;
    }
  }

  .input-upload {
    position: relative;

    input {
      position: absolute;
      width: 100%;
      height: 100%;
      min-width: 0;
      left: 0;
      top: 0;
      opacity: 0;
      font-size: 0;
      cursor: pointer;
    }
  }

  .files-path-item {
    i {
      margin: 0 6px;
    }

    &:last-child {
      i {
        visibility: hidden;
      }
    }

    &:not(:last-child) {
      color: #1983f9;

      span {
        cursor: pointer;
      }
    }
  }

  .check-handler__show {
    height: 43px;
    line-height: 43px;
    padding-bottom: 10px;
    border-bottom: 1px solid #dcdfe6;

    .handlers {
      float: right;
    }

    .upload-url-btn {
      background: none;

      &:hover {
        background: #ecf5ff;
        color: #409eff;
      }
    }
  }

  .search-select {
    margin-right: 10px;
  }
}
</style>
